import { styled } from '@mui/system'
import Breadcrumbs from '../../organisms/breadcrumbs'
import Button from '../../molecules/button'
import { Grid } from '@mui/material'
import Sortables from '../../molecules/filters/sortables/sortables'
import Sticky from '../../particles/sticky'
import { Container as StickyContainer } from '@/components/ui/organisms/sticky-banner/sticky-banner.styled'

const shouldForwardProp = (prop) => !['filtersVariant', 'maxHeight', 'offsetTop'].includes(prop)

export const Root = styled('div')`
	padding: 0;
`

export const BreadcrumbsStyled = styled(Breadcrumbs)`
	margin-top: ${({ theme }) => theme.spacing(2)};
	margin-bottom: 0;
	display: none;
	padding: var(--spacing-3);
	border-top: 1px solid var(--color-grey60);
	color: var(--color-primary);

	a {
		color: var(--color-primary);
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		display: block;
	}

	.MuiBreadcrumbs-ol {
		justify-content: center;
	}
`

export const FiltersControlsContainer = styled('div', { shouldForwardProp })`
	width: 100%;
	z-index: 2;
	margin-right: 0;
	margin-left: auto;
	.FiltersInline-root {
		background-color: ${({ theme }) => theme.palette.white.main};
		padding-top: 0;
		padding-bottom: 0;
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		width: ${({ filtersVariant }) => (filtersVariant === 'sidebar' ? 'auto' : '100%')};
	}
`

export const ControlsWrapper = styled('div', { shouldForwardProp })`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-left: auto;
	margin-right: 0;
	margin-top: ${({ filtersVariant, theme }) => (filtersVariant === 'inline' ? theme.spacing(5) : 0)};
	width: 100%;
	position: sticky;
	top: calc(var(--header-sticky-top, 0px) - 1px);
	background: ${({ theme }) => theme.palette.white.main};
	padding: ${({ theme }) => theme.spacing(2, 0)};
	z-index: 2;
	${({ theme }) => theme.breakpoints.up('md')} {
		justify-content: auto;
		position: relative;
		top: 0;
		padding: 0;
	}
	.ViewMode-root {
		margin-right: ${({ theme }) => theme.spacing(2)};
	}
`

export const Row = styled('div')`
	display: flex;
	align-items: flex-start;
	flex-wrap: wrap;
	margin-bottom: 0;

	${({ theme }) => theme.breakpoints.up('md')} {
		margin-top: 0;
		align-items: flex-end;
		padding: 0;
		border-bottom: 1px solid var(--color-grey50);
		margin-top: ${({ theme }) => theme.spacing(4)};
	}
`

export const ImageContainer = styled('div')`
	margin-bottom: ${({ theme }) => theme.spacing(2)};
	width: 100%;
`

export const Description = styled('div')`
	width: 100%;
	margin: ${({ theme }) => theme.spacing(2)} 0 ${({ theme }) => theme.spacing(5)};
	max-width: 600px;
	padding-left: ${({ theme }) => theme.spacing(1)};
	padding-right: ${({ theme }) => theme.spacing(1)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding-bottom: ${({ theme }) => theme.spacing(4)};
		padding-left: ${({ theme }) => theme.spacing(2)};
		padding-right: ${({ theme }) => theme.spacing(2)};
	}

	> div > div {
		min-height: 0;
		line-height: 22px;
	}
`

export const ListContainer = styled('div')`
	display: flex;
	align-items: flex-start;
	margin-bottom: ${({ theme }) => theme.spacing(4)};
	padding-left: ${({ theme }) => theme.spacing(1)};
	padding-right: ${({ theme }) => theme.spacing(1)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding-bottom: ${({ theme }) => theme.spacing(4)};
		padding-left: ${({ theme }) => theme.spacing(2)};
		padding-right: ${({ theme }) => theme.spacing(2)};
	}

	.FiltersSidebar-root {
		margin-bottom: 0;
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		margin-top: ${({ theme }) => theme.spacing(6)};
	}
`

export const List = styled('div', { shouldForwardProp })`
	width: 100%;
	margin-left: auto;
	margin-right: 0;
	margin-top: ${({ theme }) => theme.spacing(1)};
	.AdvancedGrid-root {
		width: 100%;
		${({ theme }) => theme.breakpoints.up('md')} {
			--scrollBarWidth: var(--global-scrollbar-width, 0px);
			width: ${({ filtersVariant, theme }) =>
				filtersVariant === 'inline' ? 'calc(100vw - ' + theme.spacing(8) + ' - var(--scrollBarWidth))' : '100%'};
		}

		.Magento-PageBuilder-Banner-Sticky {
			${StickyContainer} {
				top: 151px;
			}
		}
	}
	${({ theme }) => theme.breakpoints.up('md')} {
		margin-top: 0;
	}
`

export const ButtonToggleFilters = styled(Button)`
	margin-right: ${({ theme }) => theme.spacing(5)};
`

export const FiltersSidebarContainer = styled('div', { shouldForwardProp })`
	width: 415px;
	transition: margin 0.3s ease;
	margin-right: ${({ theme }) => theme.spacing(3)};
	position: sticky;
	top: ${({ offsetTop }) => `calc(var(--header-sticky-top, 0px) + ${offsetTop}px)`};
	max-height: ${({ maxHeight }) => `calc(100vh - ${maxHeight})`};

	border-radius: ${({ theme }) => theme.shape.borderRadius}px;
	border: 1px solid ${({ theme }) => theme.palette.grey.light};
	padding: 40px;

	${({ theme }) => theme.scrollbar};
	::-webkit-scrollbar {
		width: 5px;
	}

	&._hide {
		margin-left: -100%;
	}
	&._show {
		margin-left: 0;
	}
`

export const ButtonLoadPrev = styled(Button)`
	margin-bottom: ${({ theme }) => theme.spacing(4)};
`

export const ButtonLoadMore = styled(Button)``

export const GridPagination = styled(Grid)`
	margin-top: ${({ theme }) => theme.spacing(10)};
	margin-bottom: ${({ theme }) => theme.spacing(4)};
	.Pagination-root {
		ul {
			justify-content: center;
		}
	}
`

export const SortablesStyled = styled(Sortables)`
	&.MuiFormControl-root {
		.MuiInputBase-root {
			> .MuiSelect-select {
				letter-spacing: 0;
				padding: 0;
				&:focus {
					background: transparent;
				}
			}
			&:after,
			&:before {
				border: none !important;
			}
			&:hover {
				&:after,
				&:before {
					border: none !important;
				}
			}
		}
	}
	fieldset {
		border: 0;
	}
`

export const StickyStyled = styled(Sticky)`
	padding-left: ${({ theme }) => theme.spacing(1)};
	padding-right: ${({ theme }) => theme.spacing(1)};
	${({ theme }) => theme.breakpoints.up('md')} {
		padding-left: ${({ theme }) => theme.spacing(2)};
		padding-right: ${({ theme }) => theme.spacing(2)};
	}
	.sticky-inner-wrapper {
		z-index: 9;
		background-color: ${({ theme }) => theme.palette.white.main};
	}
	&.active {
		.sticky-inner-wrapper {
			padding: 0 var(--spacing-2);
			width: 100% !important;
			left: 0;
		}
	}
`

export const ImageDescriptionContainer = styled('div')`
	width: 100%;
`

export const LoadMoreContainer = styled(Grid)`
	padding: 40px 10px;

	${({ theme }) => theme.breakpoints.up('md')} {
		padding: 60px 60px 28px;
	}
`

export const ProgressBar = styled('div')`
	display: block;
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	height: 4px;
	border-radius: 9px;
	background-color: ${({ theme }) => theme.palette.primary.main};
`

export const ProgressBarContainer = styled('div')`
	width: 200px;
	height: 4px;
	background-color: var(--color-grey30);
	border-radius: 9px;
	margin: var(--spacing-3) auto;
	position: relative;
`

export const Wrapper = styled('div')`
	width: 100%;
	display: flex;
	padding: 0;
	flex-direction: column;

	${({ theme }) => theme.breakpoints.up('md')} {
		justify-content: flex-end;
		flex-direction: row;
		gap: var(--spacing-5);
	}
`
